module.exports = __webpack_public_path__ + "static/media/icon_privacy@2.1d08650f.png";